import React from 'react'

export default () => <a href="mailto:support@uprightlabs.com">support@uprightlabs.com</a>
